import React, { useState, lazy, Suspense } from 'react';
import { Button, Col } from '@thd-olt-component-react/core-ui';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import './product-details-button.scss';

const QuickViewLazy = lazy(() => import(
  /* webpackChunkName: "quick-view" */
  '@thd-olt-component-react/quick-view'
).then((mod) => {
  const { QuickView } = mod;
  return {
    default: (props) => {
      return (
        <QueryProvider
          dataSource="catalog"
          cacheKey="bundling-tabs-product-details-quick-item"
        >
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <QuickView {...props} />
        </QueryProvider>
      );
    }
  };
}));

export const ProductDetailsButton = ({ itemId }) => {

  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const [mountQuickView, setMountQuickView] = useState(false);

  const openQuickView = () => {
    if (!isQuickViewOpen) {
      setIsQuickViewOpen(true);
    }
  };

  const loadQuickView = (event) => {
    event.preventDefault();
    if (!mountQuickView) {
      setMountQuickView(true);
    }
  };

  return (
    <div className="product-details-button__button" data-testid="product-details-button">
      <Col fallback="12" sm="6" md="3" onMouseEnter={loadQuickView}>
        <Button
          className="bundling-product-tabs__button-details"
          dark
          outline
          onClick={openQuickView}
        >
          View Product Details
        </Button>
      </Col>
      {typeof window !== 'undefined' && mountQuickView && (
        <Suspense fallback={<div />}>
          <QuickViewLazy
            isOpen={isQuickViewOpen}
            onClose={() => setIsQuickViewOpen(false)}
            fetch={mountQuickView}
            itemId={itemId}
          />
        </Suspense>
      )}
    </div>
  );
};

ProductDetailsButton.propTypes = {
  itemId: string.isRequired,
};

ProductDetailsButton.displayName = 'ProductDetailsButton';